import Layout from "../../../components/layout/layout.js";

import MediaLibrary from "../../../components/componentsPage/mediaLibrary/medialibrary.js";

function MediaLibraryPage({ component, ...rest }) {
  return <Layout Component={MediaLibrary} controlsDisabled={true} {...rest} />;
}

export default MediaLibraryPage;
